module.exports = __webpack_public_path__ + "assets/images/scene-2_7bc7f7506962cf169c1a3d5012d42f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/croma-abeldo-dialogs/scene-2.png
// module id = 275
// module chunks = 0